import * as CardCrawl from "@ravalmatic/cardcrawl-engine";
import { GameVars } from "../../GameVars";
import { BoardContainer } from "./BoardContainer";
import { BoardScene } from "./BoardScene";
import { Card } from "./cards/Card";
import { GameManager } from "../../GameManager";
import { EventType } from "../../Types";
import { Utils } from "../../utils/Utils";
import { GameConstants } from "../../GameConstants";

export class BoardManager {

    public static init(): void {
    
        GameVars.allowedMoves = null;
        GameVars.gameOver = false;
        GameVars.victory = false;
        GameVars.paused = false;
        GameVars.f = 0;
        GameVars.cardCrawlEngine = null;

        GameVars.eventsDispatcher.addEventListener(EventType.GAME_PAUSED, BoardManager.onPauseGameListener, BoardManager);
        GameVars.eventsDispatcher.addEventListener(EventType.GAME_RESUMED, BoardManager.onResumeGameListener, BoardManager);
        GameVars.eventsDispatcher.addEventListener(EventType.CARD_PICKED, BoardManager.onCardPickedListener, BoardManager);
        GameVars.eventsDispatcher.addEventListener(EventType.CARD_DROPPED, BoardManager.onCardDroppedListener, BoardManager);
        GameVars.eventsDispatcher.addEventListener(EventType.MULLIGAN, BoardManager.onMuilliganListener, BoardManager);
        GameVars.eventsDispatcher.addEventListener(EventType.CARD_DEALT, BoardManager.onCardDealtListener, BoardManager);
        GameVars.eventsDispatcher.addEventListener(EventType.SHOW_CARD_DESCRIPTION, BoardManager.showCardDescriptionListener, BoardManager);
        GameVars.eventsDispatcher.addEventListener(EventType.HIDE_MESSAGE, BoardManager.hideMessageListener, BoardManager);
        GameVars.eventsDispatcher.addEventListener(EventType.CARD_RETURNED_TO_DECK, BoardManager.onCardReturnedToDeck, BoardManager);
        GameVars.eventsDispatcher.addEventListener(EventType.EXTRA_ATTACK, BoardManager.onExtraAttackListener, BoardManager);

        BoardManager.startGame();
    }

    public static update(): void {
        
        GameVars.f ++;
    }

    public static onGameOverRewardedAdShown(): void {

        GameVars.gameData.gold += GameConstants.REWARDED_AD_EXTRA_GOLD;
        GameManager.writeGameData();
        
        BoardScene.currentInstance.gameOverLayer.updateGold(1000, 0, true);
    }

    private static startGame(): void {

        const difficulty = GameVars.gameData.numPlayedGames < 7 ? CardCrawl.Difficulty.EASY : CardCrawl.Difficulty.MEDIUM;
        const config: CardCrawl.Config = {
            difficulty: difficulty,
            finalGold: GameConstants.FINAL_GOLD,
        };
        
        GameVars.cardCrawlEngine = new CardCrawl.Engine(config);
       
        GameVars.cardCrawlEngine.addEventListener(CardCrawl.EventType.ACTION_PROCESSED, BoardManager.onActionProcessedListener, BoardManager);
        GameVars.cardCrawlEngine.addEventListener(CardCrawl.EventType.GAME_OVER, BoardManager.onGameOverListener, BoardManager);
        
        // let testState = GameConstants.TEST_STATE;
        let testState = null;

        GameVars.cardCrawlEngine.init(GameVars.gameData.specialCards, testState, null, Math.floor(Math.random() * 1e4)); 

        BoardScene.currentInstance.startGame();
    }

    private static onPauseGameListener(args: any[]): void {

        GameVars.paused = true;

        BoardScene.currentInstance.pauseGame();
    }

    private static onResumeGameListener(args: any[]): void {

        BoardScene.currentInstance.time.delayedCall(100, () => GameVars.paused = false, [], BoardManager);

        BoardScene.currentInstance.resumeGame();
    }

    private static onCardPickedListener(args: any[]): void {

        const card = args[0] as Card;

        const state = GameVars.cardCrawlEngine.getState();

        GameVars.allowedMoves = CardCrawl.Utils.getValidMoves(card.id, state);

        if (GameVars.allowedMoves) {
            BoardContainer.currentInstance.showAllowedMoves(card.cardData);
        }
    }

    private static onCardDroppedListener(args: any[]): void {

        const [id, item, i] = args;

        const card = CardCrawl.Utils.getCardDataById(id, GameVars.cardCrawlEngine.getState());

        if (item === CardCrawl.TableauType.SHOP) {
            GameVars.cardCrawlEngine.processAction({type: CardCrawl.ActionType.SELL_CARD, card: card, data: null});
        } else {
            GameVars.cardCrawlEngine.processAction({type: CardCrawl.ActionType.MOVE_TO_TABLEAU, card: card, data: {tableau: item, i: i}});
        }
    }

    private static onCardDealtListener(args: any[]): void {

        BoardScene.currentInstance.onCardDealt();
    }

    private static onMuilliganListener(args: any[]): void {

        GameVars.cardCrawlEngine.processAction({type: CardCrawl.ActionType.MULLIGAN, card: null, data: null});
    }

    private static onExtraAttackListener(args: any[]): void {

        GameVars.cardCrawlEngine.processAction({type: CardCrawl.ActionType.EXTRA_ATTACK, card: null, data: null});
    }

    private static onActionProcessedListener(): void {

        BoardScene.currentInstance.onActionProcessed();
    }

    private static showCardDescriptionListener(args: any[]): void {

        const cardData = args[0] as CardCrawl.CardData;
        const msg = Utils.getSpecialCardDescription(cardData.type);

        BoardScene.currentInstance.showMessageLayer(msg);
    }

    private static hideMessageListener(args: any[]): void {
            
        BoardScene.currentInstance.hideMessageLayer();
    }

    private static onCardReturnedToDeck(args: any[]): void {
        // NADA
    }

    private static onGameOverListener(): void {

        GameVars.gameOver = true;

        const state = GameVars.cardCrawlEngine.getState();
       
        GameVars.victory = GameVars.cardCrawlEngine.getState().lowerTableau[1].value > 0;

        BoardScene.currentInstance.onActionProcessed();
        BoardScene.currentInstance.onGameOver();

        GameVars.gameData.numPlayedGames ++;
        GameVars.gameData.gold += state.lowerTableau[1].gold;
        GameManager.writeGameData();
    }
}
